import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontBarlowSemiCondensed, fontRobotoCondensed } from "shared/lib/styles";

import LogoFlag from "scmp-app/components/section/section-style/icon-logo-style-flag.svg";
import LogoText from "scmp-app/components/section/section-style/icon-logo-style-text.svg";

import { HamburgerMenuMagazinesStyleTopStories } from "./hamburger-menu-magazines-style-top-stories";
import CloseIcon from "./icon-close.svg";
import FacebookIcon from "./icon-facebook.svg";
import InstagramIcon from "./icon-instagram.svg";
import ScmpLogo from "./icon-scmp-logo.svg";

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const StyledLogoFlag = styled(LogoFlag)`
  align-self: center;

  inline-size: 28px;
`;

export const StyledLogoText = styled(LogoText)`
  align-self: end;

  inline-size: 42px;
`;

export const StyleHomeLink = styled(BaseLink)`
  position: relative;
  inset-inline-start: -16px;

  display: flex;
  flex-direction: row;
  gap: 16px;

  block-size: 33px;
  margin-block: 16px;
`;

export const StyledCloseIcon = styled(CloseIcon)`
  position: relative;
  inset-inline-end: -16px;

  inline-size: 18px;
  block-size: 18px;

  cursor: pointer;
`;

export const StyledTopStories = styled(HamburgerMenuMagazinesStyleTopStories)``;

export const StayOnTrendTitle = styled.div`
  color: #222222;
  font-weight: 600;
  font-size: 14px;
  font-family: ${fontBarlowSemiCondensed};
  line-height: 16.8px;
  letter-spacing: -0.001em;
  text-transform: uppercase;
`;

export const StayOnTrendSubTitle = styled.div`
  color: #222222;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontBarlowSemiCondensed};
  line-height: 16.8px;
  letter-spacing: -0.001em;
`;

export const StayOnTrendButton = styled.div`
  margin: 8px;
  padding-block: 8px;
  padding-inline: 24px;

  color: #222222;
  font-weight: 600;
  font-size: 12px;
  font-family: ${fontBarlowSemiCondensed};
  line-height: 12.4px;
  letter-spacing: 0.1em;
  text-transform: uppercase;

  border: 1px solid #222222;
  border-radius: 4px;
`;

export const StayOnTrend = styled.div`
  display: inline-flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;

  text-align: center;
`;

export const FollowFacebookIcon = styled(FacebookIcon)``;
export const FollowInstagramIcon = styled(InstagramIcon)``;
export const FollowLinkGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

export const FollowTitle = styled.div`
  color: #222222;
  font-weight: 400;
  font-size: 13px;
  font-family: ${fontBarlowSemiCondensed};
  line-height: 15px;
  letter-spacing: -0.001em;
  text-transform: uppercase;
`;

export const Follow = styled.div`
  display: inline-flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;

  text-align: center;
`;

export const StyledScmpLogo = styled(ScmpLogo)``;

export const LatestNews = styled.div`
  color: #222222;
  font-weight: 400;
  font-size: 13px;
  font-family: ${fontBarlowSemiCondensed};
  line-height: 15px;
  letter-spacing: -0.001em;
  text-transform: uppercase;
`;

export const NewsHomeLink = styled(BaseLink)`
  display: inline-flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;

  text-align: center;
`;

export const News = styled.div`
  text-align: center;
`;

export const Link = styled.a`
  color: #777777;
  font-weight: 400;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  line-height: 15px;
  letter-spacing: -0.001em;
  text-transform: uppercase;
`;

export const Terms = styled.div``;
export const Privacy = styled.div``;
export const Logout = styled.div``;
export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  gap: 16px;
  justify-content: center;
  align-items: end;

  margin-block: 24px;

  ${Logout} {
    flex: 1 1;

    text-align: end;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-flow: column;

  inline-size: 100%;
  block-size: 100%;
  padding-inline: 32.5px;

  background-color: #ffffff;

  overflow: hidden auto;

  ${StyledTopStories}, ${StayOnTrend}, ${Follow}, ${News} {
    padding-block: 40px;
  }

  ${StyledTopStories}, ${StayOnTrend}, ${Follow} {
    border-block-end: 1px solid #bbbbbb;
  }
`;
